// extracted by mini-css-extract-plugin
module.exports = {"trigger":"AnimationsPaneTrigger_trigger__1o9cj","triggerActive":"AnimationsPaneTrigger_triggerActive__3iYpg"};